import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getEnvConfiguration } from '../../reducers';
import useEffectOnLoad from '../../hooks/useEffectOnLoad';
import { loadEnvConfiguration } from '../../actions/settings';
import useAuthentication from '../../hooks/useAuthentication';
import ExpandedListTab from '../ExpandedListTab';
import EnvironmentConfigurationTable from './EnvironmentConfigurationTable';
import Spinner from '../Spinner';

function EnvironmentConfigurationDetailTab() {
    const envConfiguration = useSelector(getEnvConfiguration);
    const dispatch = useDispatch();
    const { accessToken } = useAuthentication();
    useEffectOnLoad(() => {
        dispatch(loadEnvConfiguration(accessToken));
    });
    let result;
    if (envConfiguration) {
        const configPairs = _.toPairs(envConfiguration).sort((first, second) => first[0].localeCompare(second[0]));
        result = <EnvironmentConfigurationTable configPairs={configPairs} />;
    } else {
        result = <Spinner className="env-configuration-loading" />;
    }
    return (
        <ExpandedListTab
            className="settings-detail-tab"
            scrollToTop
        >
            {result}
        </ExpandedListTab>
    );
}

export default EnvironmentConfigurationDetailTab;
